// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart-items .card {
  width: 16rem;
  margin: 1rem;
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 1rem;
  background-color: #939393;
  background-image: linear-gradient(
      135deg,
      rgba(255, 255, 255, 0.3) 0%,
      transparent 100%
    ),
    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,
    0 0 0 2px rgba(0, 0, 0, 0.05);
  border: none;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  overflow: hidden;
}

.cart-title {
  margin: 1.5rem;
  display: flex;
  justify-content: center;
  gap: 2.5rem;
  font-size: 1.75rem;
  font-weight: bold;
}

.cart-container {
  display: flex;
  flex-direction: row;
}

.cart-items {
  margin: 1rem;
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

.cart-summary {
  position: fixed;
  margin: 1rem;
  width: 16rem;
  height: 9rem;
  right: 2vw;
  background-color: #247a97;
  border-radius: 1rem;
  border: none;

  background-color: #247a97;
  fill: #ffffff;
  color: #ffffff;
  position: absolute;
  letter-spacing: 0.5px;
  transition: transform 0.3s;
  font-size: 1rem;
  font-weight: 600;
  border-width: 4px 4px 4px 4px;
  border-style: solid;
  padding: 15px 40px 15px 40px;
  box-shadow: 5px 5px 5px 0px
    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);
}

.cart-total {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: bold;
  color: #fff;
}

.total-items {
  font-size: 1.25rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: #ffffff;
}

.checkout-button {
  background-color: #ffeb3b;
  font-size: 1.25rem;
  color: #000;
  display: block;
  width: 100%;
  padding: 0.625rem;
  margin-top: 2vh;
  text-align: center;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
}

@media screen and (max-width: 991px) {
  .cart-title {
    font-size: 5rem;
  }

  .cart-container {
    flex-direction: column;
    align-items: center;
  }

  .cart-items {
    justify-content: center;
    flex-wrap: wrap;
  }

  .cart-items .card {
    width: calc(50% - 2rem);
    margin: 1.75rem 1rem;
  }

  .cart-summary {
    width: 100%;
    position: relative;
    order: -1;
  }

  .cart-total,
  .total-items,
  .checkout-button {
    font-size: 3rem;
  }

  .card-product-name {
    font-size: 1.5rem;
  }

  .card-body {
    scale: 1.6;
  }

  .remove-cart-btn {
    scale: 1.3;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/Cart.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB;;;;;4EAK0E;EAC1E;iCAC+B;EAC/B,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;;EAEZ,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;EAC5B;0DACwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;EACX;;EAEA;;;IAGE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".cart-items .card {\n  width: 16rem;\n  margin: 1rem;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-radius: 1rem;\n  background-color: #939393;\n  background-image: linear-gradient(\n      135deg,\n      rgba(255, 255, 255, 0.3) 0%,\n      transparent 100%\n    ),\n    linear-gradient(to right, rgba(255, 255, 255, 0.1) 25%, transparent 25%);\n  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1) inset,\n    0 0 0 2px rgba(0, 0, 0, 0.05);\n  border: none;\n  -webkit-backdrop-filter: blur(40px);\n  backdrop-filter: blur(40px);\n  overflow: hidden;\n}\n\n.cart-title {\n  margin: 1.5rem;\n  display: flex;\n  justify-content: center;\n  gap: 2.5rem;\n  font-size: 1.75rem;\n  font-weight: bold;\n}\n\n.cart-container {\n  display: flex;\n  flex-direction: row;\n}\n\n.cart-items {\n  margin: 1rem;\n  display: flex;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n\n.cart-summary {\n  position: fixed;\n  margin: 1rem;\n  width: 16rem;\n  height: 9rem;\n  right: 2vw;\n  background-color: #247a97;\n  border-radius: 1rem;\n  border: none;\n\n  background-color: #247a97;\n  fill: #ffffff;\n  color: #ffffff;\n  position: absolute;\n  letter-spacing: 0.5px;\n  transition: transform 0.3s;\n  font-size: 1rem;\n  font-weight: 600;\n  border-width: 4px 4px 4px 4px;\n  border-style: solid;\n  padding: 15px 40px 15px 40px;\n  box-shadow: 5px 5px 5px 0px\n    rgba(12, 11.000000000000002, 11.000000000000002, 0.77);\n}\n\n.cart-total {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: bold;\n  color: #fff;\n}\n\n.total-items {\n  font-size: 1.25rem;\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  color: #ffffff;\n}\n\n.checkout-button {\n  background-color: #ffeb3b;\n  font-size: 1.25rem;\n  color: #000;\n  display: block;\n  width: 100%;\n  padding: 0.625rem;\n  margin-top: 2vh;\n  text-align: center;\n  border: none;\n  border-radius: 0.25rem;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 991px) {\n  .cart-title {\n    font-size: 5rem;\n  }\n\n  .cart-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .cart-items {\n    justify-content: center;\n    flex-wrap: wrap;\n  }\n\n  .cart-items .card {\n    width: calc(50% - 2rem);\n    margin: 1.75rem 1rem;\n  }\n\n  .cart-summary {\n    width: 100%;\n    position: relative;\n    order: -1;\n  }\n\n  .cart-total,\n  .total-items,\n  .checkout-button {\n    font-size: 3rem;\n  }\n\n  .card-product-name {\n    font-size: 1.5rem;\n  }\n\n  .card-body {\n    scale: 1.6;\n  }\n\n  .remove-cart-btn {\n    scale: 1.3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
